export default __webpack_public_path__ + "static/media/icon-coin-flux.29234b5d.svg";